export default {
    apiKey: "AIzaSyCfvxP5qk2_Tq1u3YNzUExUFHoEZTBBH9Q",
    authDomain: "demoapp257.firebaseapp.com",
    databaseURL: "https://demoapp257.firebaseio.com",
    projectId: "demoapp257",
    storageBucket: "demoapp257.appspot.com",
    messagingSenderId: "159970875437"
}




// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js